import React, { h } from "preact";
import {t} from "../../_i18n";
import {Card} from "../../_common/layout";
import {ButtonGhost} from "../../_common/components/buttons/buttons";
import {Section, TextLabel} from "./components";
import {Link} from "react-router-dom";

export default function SocialSecurityData({socialSecurity, changeSocialSecurityLink}) {

    return (
        <div className='p-left-half sm-no-p-left p-right-half sm-no-p-right'>
            <Card className='m-top sm-p-x2-bottom'>
                <div className='font-24 font-medium m-top'>{t('Datos de la Seguridad Social')}</div>
                <Section className='m-top'>
                    <TextLabel label={t('Número de Afiliación de la Seguridad Social')} value={socialSecurity}/>
                    <Link to={changeSocialSecurityLink}><ButtonGhost className='m-top sm-no-m-top full-width sm-no-full-width'>{t('Cambiar')}</ButtonGhost></Link>
                </Section>
            </Card>
        </div>
    )
}
